// ----------------------------------------------------------
// © Copyright 2021 European Space Agency, 2021
// This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this [source code/executable] package. No part of the package, including this file, may be copied, modified, propagated, or distributed except according to the terms contained in the file ‘LICENSE.txt’.
// -----------------------------------------------------------
import { modalController } from "@ionic/core";
import { Logger } from "./logger";
const logger = new Logger("helper", "modal-manager");
export var ModalType;
(function (ModalType) {
    ModalType["FORM"] = "form-modal";
    ModalType["ALERT"] = "alert-modal";
})(ModalType || (ModalType = {}));
/**
 * Interface to manipulate the modal, hide, show
 */
export class ModalManager {
    constructor(modalType = ModalType.FORM) {
        this.modalType = modalType;
    }
    /**
     * Show a modal with the component provided and handle the event from the modal
     * @param component the component to show in the modal
     * @param options The options for the modal
     */
    async showModal(component, options = {}) {
        logger.debug("Modal is showing...");
        this.modal = await modalController.create(Object.assign(Object.assign({ component: component }, options), { cssClass: this.modalType }));
        await this.modal.present();
        return this.addModalEventListener();
    }
    addModalEventListener() {
        const ionModals = document.getElementsByTagName("ion-modal");
        if ((ionModals === null || ionModals === void 0 ? void 0 : ionModals.length) > 0) {
            // take the latest added so we are sure this is the current one
            // possible race condition if multiple modal are added at the same moment
            const htmlModal = ionModals[ionModals.length - 1];
            htmlModal.addEventListener("close", () => { this._close(); });
            // return the modal so that we can add more event
            return htmlModal;
        }
        else {
            // worst case scenario we can't retrieve it, possible workaround delay a bit so we are sure the element is in the dom
            throw new Error("Unable to retrieve the modal, the auto closure with X won't work");
        }
    }
    /**
     * Close event handler, it will close the modal using the hideModal function
     * then it will trigger the event to let listener that the modal was closed
     * @private
     */
    async _close() {
        logger.debug("Modal is closing...");
        await this.hideModal();
        // trigger an event
        if (this.onClose) {
            this.onClose();
        }
    }
    /**
     * Closing the modal but do not trigger a close event as this was done from the API and thus known from the caller
     */
    async hideModal() {
        logger.debug("Modal is dismissing...");
        // hide the modal
        await this.modal.dismiss();
    }
}
